import { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PreferenceTypeTwo } from '../../../../Form/Preference';
import styles from './JobPreferences.module.scss';
import { validationMessages } from '../../../../../utils/constants';
import { usePrevious, useWindowSize } from '../../../../../utils/hooks';
import { FunctionsForm, IndustriesForm } from '../../../../common/ModalWindows/components';
import Terms from '../Terms/Terms';

export function JobPreferences({
  updateRates,
  validationErrors,
  contractType,
  setContractType,
  profile,
  updating,
  industriesForm,
  functionsForm
}) {
  const prevUpdating = usePrevious(updating);

  useWindowSize();
  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  const contract = [
    {
      id: 0,
      label: t('dashboard.profile.details.contractwork'),
      option: 'ContractWork',
      selected: profile?.ContractWork
    },
    {
      id: 1,
      label: t('dashboard.profile.details.permenantwork'),
      option: 'PermanentWork',
      selected: profile?.PermanentWork
    }
  ];

  const [, setEditIndustries] = useState(false);
  const [, setEditFunctions] = useState(false);
  const [, setEditContract] = useState(false);
  const [, setEditWorkLocation] = useState(false);
  const [userRatesLocaly, setUserRatesLocaly] = useState(profile?.UserRates?.[0] ?? null);

  useEffect(() => {
    if (prevUpdating === true && updating === false) {
      setEditContract(false);
      setEditWorkLocation(false);
      setEditIndustries(false);
      setEditFunctions(false);
    }
  }, [updating]);

  const handleUpdateRates = (data) => {
    setUserRatesLocaly(data);
    updateRates(data);
  };

  return (
    <div className={`mt-4 ${styles.JobPreferences} flex gap-4 flex-col`}>
      <div className="flex flex-col">
        <p className="text-navy-blue font-medium">{t('dashboard.profile.details.industries')}</p>
        <div className="flex flex-col">
          {/* <ActionsButton activityName="edit" clickHandler={() => setEditIndustries(true)} /> */}
          {/* {editIndustries && (
            <AddEditFormModal
              open
              key={profile?.UserIndustries}
              closeHandler={() => setEditIndustries(false)}
              editeMode
              initData={profile?.UserIndustries}
              confirmHandler={confirmIndustryHandler}
              block="industries"
              pending={updating}
            />
          )} */}
          {industriesForm && <IndustriesForm addEditForm={industriesForm} />}
        </div>
        {/* <div className={styles.chipsContainer}>
          {profile?.UserIndustries.map((item) => (
            <ThemeProvider key={item.Industry.Id} theme={theme}>
              <Chip className={styles.chip} label={item.Industry.Name} color="primary" variant="filled" />
            </ThemeProvider>
          ))}
        </div> */}
      </div>
      <div className="flex flex-col">
        <p className="text-navy-blue font-medium">{t('dashboard.profile.details.jobfunctions')}</p>
        <div className="flex flex-col">
          {/* <ActionsButton activityName="edit" clickHandler={() => setEditFunctions(true)} />
          {editFunctions && (
            <AddEditFormModal
              open
              key={profile?.UserJobFunctions}
              closeHandler={() => setEditFunctions(false)}
              editeMode
              initData={profile?.UserJobFunctions}
              confirmHandler={confirmFunctionsHandler}
              block="functions"
              pending={updating}
            />
          )} */}
          {industriesForm && <FunctionsForm addEditForm={functionsForm} />}
        </div>
        {/* <div className={styles.chipsContainer}>
          {profile?.UserJobFunctions.map((item) => (
            <ThemeProvider key={item.JobFunction.Id} theme={theme}>
              <Chip className={styles.chip} label={item.JobFunction.Name} color="primary" variant="filled" />
            </ThemeProvider>
          ))}
        </div> */}
      </div>
      <div className="flex flex-col">
        <p className="text-navy-blue font-medium pb-4">{t('dashboard.profile.details.contracttypes')}</p>
        <div className="flex flex-col border-b-1 border-gray-200 pb-6">
          {/* <ActionsButton activityName="edit" clickHandler={() => setEditContract(true)} />
          <BaseModal
            title={t('dashboard.modal.edit.contracttypes')}
            open={editContract}
            fullscreen={size.width < maxMobileSize}
            closeHandler={() => {
              setEditContract(false);
              setContractType({
                ContractWork: profile?.ContractWork,
                PermanentWork: profile?.PermanentWork
              });
            }}
            confirmHandler={confirmContractHandler}
            pending={updating}
          >
          </BaseModal> */}
          {contractType && (
            <PreferenceTypeTwo
              fields={contract}
              state={contractType}
              setState={setContractType}
              errorMsg={validationMessage.TYPE_WORK_CHOOSE_ONE}
            />
          )}
        </div>
        {/* <div className={styles.chipsContainer}>
          <PreferenceTypeTwo fields={contract} state={contractType} setState={() => false} disabled />
        </div> */}
      </div>

      <div className="flex flex-col">
        <p className="text-navy-blue font-medium pb-4">{t('dashboard.modal.terms')}</p>
        <div className="flex flex-col border-b-1 border-gray-200 pb-6">
          <Terms userRates={userRatesLocaly} updateUserRates={handleUpdateRates} errors={validationErrors} />
        </div>
      </div>
    </div>
  );
}
